// Added by sephora-jsx-loader.js
var React = require('react');
// Added by sephora-jsx-loader.js
var wrapComponentRenderModule = require('utils/framework/wrapComponentRender'); // eslint-disable-line max-len
// Added by sephora-jsx-loader.js
var createClass = require('create-react-class')

// Added by sephora-jsx-loader.js
var wrapComponentRender = wrapComponentRenderModule.wrapComponentRender; // eslint-disable-line max-len
// Added by sephora-jsx-loader.js
if (process.env.NODE_ENV === 'development' && !React.PropTypes) {
    React.PropTypes = require('prop-types');
}
// Added by sephora-jsx-loader.js
/* eslint-disable max-len */
// Added by sephora-jsx-loader.js
var TestTargetClass;// Added by sephora-jsx-loader.js
/* eslint-enable max-len */
/*global React*/
const PropTypes = require('prop-types');
const BccStyleWrapper = require('components/Bcc/BccStyleWrapper/BccStyleWrapper');

const TestTarget = function () {
    this.state = {
        showSkeleton: this.props.skeleton,
        displayComponent: null,
        updateProps: null,
        componentHidden: null
    };
};

TestTarget.prototype.render = function () {
    const {
        testName, testEnabled, index, isBcc, hideTestWithoutCase, skeleton, ...defaultProps
    } = this.props;
    const { componentHidden, displayComponent, showSkeleton, updateProps } = this.state;
    let componentProps;

    if (isBcc) {
        /* BCC component renders with its original props in the case of show & hide tests. */
        componentProps = defaultProps;
    } else {
        // eslint-disable-next-line object-curly-newline
        componentProps = updateProps
            ? {
                ...defaultProps,
                ...updateProps
            }
            : defaultProps;
    }

    if (hideTestWithoutCase && !componentProps.testTarget) {
        return null;
    } else if (showSkeleton) {
        return skeleton;
    } else {
        const WrappedComponent = displayComponent;
        const element = displayComponent ? <WrappedComponent {...componentProps} /> : null;

        if (isBcc && !componentHidden && componentProps.styleList) {
            return <BccStyleWrapper customStyle={componentProps.styleList}>{element}</BccStyleWrapper>;
        } else {
            return element;
        }
    }
};

TestTarget.prototype.asyncRender = 'TestTarget';

TestTarget.prototype.propTypes = {
    testName: PropTypes.string.isRequired,
    testComponent: PropTypes.func.isRequired,
    testEnabled: PropTypes.bool.isRequired
};

// Added by sephora-jsx-loader.js
Sephora.Util.InflatorComps.Comps['TestTarget'].class = TestTarget; // eslint-disable-line max-len
// Added by sephora-jsx-loader.js
/* eslint-disable max-len */
// Added by sephora-jsx-loader.js
Object.assign(TestTarget.prototype, require('./TestTarget.c.js'));// Added by sephora-jsx-loader.js
var originalDidMount = TestTarget.prototype.componentDidMount;
TestTarget.prototype.componentDidMount = function(){
    //console.log('Non-root componentDidMount Fired: TestTarget');
    if (originalDidMount) {
        originalDidMount.apply(this);
    }
    if (this.ctrlr) {
        this.ctrlr(this.props.ctrlrArgs);
    }
};
//console.log('Applied non-root componentDidMount: TestTarget');
// Added by sephora-jsx-loader.js
TestTarget.prototype.hasCtrlr = 'true';
// Added by sephora-jsx-loader.js
/* eslint-enable max-len */
// Added by sephora-jsx-loader.js
/* eslint-disable max-len */
// Added by sephora-jsx-loader.js
TestTarget.prototype.class = TestTarget.prototype.displayName = 'TestTarget';
// Added by sephora-jsx-loader.js
TestTarget.prototype.render = wrapComponentRender(TestTarget);
// Added by sephora-jsx-loader.js
// .jsx// Added by sephora-jsx-loader.js

TestTarget.prototype.getInitialState = function() {
    TestTarget.apply(this, this.props.constructorArgs);
    return this.state;
};
TestTarget.prototype.originClass = TestTarget;
TestTargetClass = createClass(TestTarget.prototype);
TestTargetClass.prototype.classRef = TestTargetClass;
Object.assign(TestTargetClass, TestTarget);
TestTargetClass.isComponent = true;
module.exports = TestTargetClass;
// Added by sephora-jsx-loader.js
/* eslint-enable max-len */
// Added by sephora-jsx-loader.js

